import axios from 'axios';

interface InputInterface {
	body?: object
	user_id?: string,
	post_id?: string,
	product_id?: string,
	term_id?: string,
	term_name?: string,
	offset?: number
}

class Api {

	private callApi = (endpoint: string, method: string = 'GET', body: object = null): Promise<any> => {
		return new Promise((resolve, reject) => {
			return axios({
				headers: {
					'Content-Type': 'application/json'
				},
				method: method,
				url: `${process.env.REACT_APP_API_HOST}/${endpoint}`,
				data: body
			}).then((response: any) => {
				var language = localStorage.getItem('i18nextLng');
				let data: any = response.data;
				if (data.error_code === 3) {
					if (language === 'en') {
						console.log('Error input data: ' + data.message);
					} else {
						console.log('Thông tin chưa đúng: ' + data.message);
					}
				}
				if (data.error_code === 0) {
					return resolve(data);
				} else {
					return reject(data);
				}
			}).catch((err: any) => {
				return reject(err);
			});
		});
	};

	public getPosts = (data) => {
		var params = Object.keys(data).map(function (k) {
			return (k + '=' + data[k]);
		}).join('&');
		return this.callApi(`get/posts?${params}`);
	};

	public getSetting = () => {
		return this.callApi(`get/setting/site`, 'GET');
	};

	public getPost = (data: InputInterface) => {
		return this.callApi(`get/post/${data.post_id}`);
	};

	public getUsers = () => {
		return this.callApi(`get/users`);
	};

	public getTaxonomies = (data) => {
		var params = Object.keys(data).map(function (k) {
			return (k + '=' + data[k]);
		}).join('&');
		return this.callApi(`get/taxonomies?${params}`);
	};

	public getOneTerm = (data: InputInterface) => {
		return this.callApi(`get/taxonomie/${data.term_id}/${data.term_name}`);
	};

	public getProducts = (data) => {
		var params = Object.keys(data).map(function (k) {
			return (k + '=' + data[k]);
		}).join('&');
		return this.callApi(`get/products?${params}`);
	};

	public getProduct = (data: InputInterface) => {
		return this.callApi(`get/product/${data.product_id}`);
	};

	public getRelatedProduct = (data: InputInterface) => {
		return this.callApi(`get/related/product`, 'POST', data.body);
	};

	public newLetter = (data: InputInterface) => {
		return this.callApi(`news-letter`, 'POST', data.body);
	};

}

export default new Api();


// WEBPACK FOOTER //
// ./src/services/index.tsx